import BaseModel from "./BaseModel";
import moment from "moment";

export default class Location extends BaseModel {

	static entity = 'locations';
	static route = 'locations';
	static plural = 'locations';
	static singular = 'location';

	static fields () {
		return {
			id: this.attr(null),
			name: this.attr(null),
			latitude: this.attr(null),
			longitude: this.attr(null),
			zoom: this.attr(null),
			address: this.attr(null),
			street_address: this.attr(null),
			city: this.attr(null),
			region: this.attr(null),
			country: this.attr(null),
			postal: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null)
		}
	}

	static isExpired(location) {
		if(!location || !location.id) {
			return false;
		} else if(location.updated_at) {
			return moment(location.updated_at).diff(moment(), 'months') >= 6;
		} else if(location.created_at) {
			return moment(location.created_at).diff(moment(), 'months') >= 6;
		}
		return true;
	}

}
